import Vue from 'vue'
import Router from 'vue-router'
import { getAuth } from 'firebase/auth'
import { screenEvent } from '../util/analyticsUtil'

import routePaths from './routes'

import resolveRoutes from './resolveRoutes'

Vue.use(Router)

const createRouter = () => {
  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: resolveRoutes(Vue)
  })

  router.beforeEach((to, from, next) => {
    const user = getAuth().currentUser
    const requiresAuth = to.matched.some(r => r.meta.requiresAuth)
    const noAuthentication = to.matched.some(r => r.meta.noAuthentication)
    const returnAfterAuth = from.meta.returnAfterAuth

    // TODO: Set the document title based on final destination or default to quickytools

    const accountRoute = routePaths.account
    // Clear the pre auth route if next is not login/register screen since data is stale
    if (!accountRoute.isAuthRoute(to ? to.path : '')) {
      router.preAuthRoute = null
    }

    // Specifying next() with {path} keeps to while changing from.
    // Working off of to and from results in an infinite loop because the paths won't differ.
    // Keep and compare router state to advance paths as directed.
    const isRedirecting = router.isRedirecting
    router.isRedirecting = false

    // Edge case from login > register keeping query params
    if (!isRedirecting &&
        from.path === accountRoute.login &&
        Object.keys(from.query).length &&
        to &&
        to.path === accountRoute.register) {
      router.isRedirecting = true
      next({ path: to.path, query: from.query })
    } else if (requiresAuth && !user) {
      // Requiring auth but not auth'd directs to login
      router.preAuthRoute = to
      // TODO: Write test query is forwarded
      next({ path: accountRoute.login, query: to.query })
    } else if (noAuthentication && user) {
      next(accountRoute.home)
    } else {
      router.returnAfterAuth = returnAfterAuth
      next()
    }
  })

  router.afterEach((to, from) => {
    const onScreenChange = () => screenEvent(document.location.pathname)
    onScreenChange()
    window.addEventListener('hashchange', onScreenChange)
  })

  return router
}

let routerInstance
export default {
  getRouter: () => {
    if (!routerInstance) {
      routerInstance = createRouter()
    }
    return routerInstance
  }
}
